import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/services/detail/page'));
const CoachsPage = lazy(() => import('../pages/coachs/page'));
const BecomeCoachPage = lazy(() => import('../pages/become-coach/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const PaymentPage = lazy(() => import('../pages/payment/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Composant de chargement
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
      <p className="mt-4 text-gray-600">Chargement...</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/coachs',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <CoachsPage />
      </Suspense>
    ),
  },
  {
    path: '/services',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <ServicesPage />
      </Suspense>
    ),
  },
  {
    path: '/service-detail',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <ServiceDetailPage />
      </Suspense>
    ),
  },
  {
    path: '/a-propos',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <AboutPage />
      </Suspense>
    ),
  },
  {
    path: '/contact',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <ContactPage />
      </Suspense>
    ),
  },
  {
    path: '/connexion',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: '/devenir-coach',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <BecomeCoachPage />
      </Suspense>
    ),
  },
  {
    path: '/paiement',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <PaymentPage />
      </Suspense>
    ),
  },
  {
    path: '/mes-reservations',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <DashboardPage />
      </Suspense>
    ),
  },
  {
    path: '/parametres',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <SettingsPage />
      </Suspense>
    ),
  },
  {
    path: '/admin',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <AdminPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

export default routes;
